const FormInput = (props) => {
    return (
        <input 
            className='focus:outline-1 focus:outline-accent py-2.5 px-3 gap-2.5 self-stretch border border-neutral5 rounded mt-1.5 font-montserrat h-10'
            style={{ borderColor: props.error ? '#E85F5C' : null }}
            id={props.id} 
            type={props.type}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange}
            maxLength={props.maxLength}
        />
    )
}

export default FormInput